import PageModule from "@eisinc/Overrides/Pages/SavedPaymentsPage";

export * from "@eisinc/Overrides/Pages/SavedPaymentsPage";

export default PageModule;
